import React, { useEffect, useState }  from 'react'
import { useQuery } from 'react-query';
import { getApiData } from '../repository/api';
import logo from '../icons/belize-flag.png';
import positive from '../icons/positive.png';
import recovered from '../icons/recovered.png';
import negative from '../icons/negative.png';
import swab from '../icons/swab.png';
import death from '../icons/death.png';
import search from '../icons/search.png';
import active from '../icons/active.png';

export default function Header() {
  const { data, isLoading, refetch } = useQuery('latestdata', getApiData, {refetchOnWindowFocus: false});
  console.log(data);
  const [date, setDate] = useState('');
  useEffect(() => { 
    if (data) {
      let date = Number(data.data[0].lastUpdate);
      let formmatedDate = new Date(date);
      setDate(formmatedDate.toDateString()); 
    }
  }, [data, isLoading, date]);
  return (
    <div className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>
          <span className="virus" role="img" aria-label="virus">
            🦠
          </span>{' '}
          Belize Coronavirus (covid-19) cases and live updates{' '}
          <span className="virus" role="img" aria-label="virus">
            🦠
          </span>
        </h1>
        <h4>
          🇧🇿 Total Cases: {isLoading ? 'loading...' : data?.data[0].confirmed} 🇧🇿 <br />
          <br /> <span>Last Updated: {isLoading ? 'loading...' : date}</span>
        </h4>
        <div className="date-picker">
          <label>Covid on this day: </label>
          <input type="date" id="search" name="search" onChange={(e) =>  { 
                setDate(e.target.value);
                refetch()
              } 
            }/>  
        </div>
        <div className="screening-data">
          <div className="btn">
            <p className="title">Test Done</p>
            <img src={swab} alt="Belize Coronavirus updates" />
            <p className="text">unavailable</p>
          </div>
          <div className="btn">
            <p className="title">Under Investigation</p>
            <img src={search} alt="Belize Coronavirus under investigation" />
            <p className="text">unavailable</p>
          </div>
          <div className="btn">
            <p className="title">Negative</p>
            <img src={negative} alt="Belize negative cases" />
            <p className="text">unavailable</p>
          </div>
          <div className="btn">
            <p className="title">Confirmed</p>
            <img src={positive} alt="Belize Coronavirus confirmed" />
            <p className="text"> {isLoading ? 'loading...' : data?.data[0].confirmed} </p>
          </div>
          <div className="btn">
            <p className="title">Deseased</p>
            <img src={death} alt="Belize Coronavirus deseased" />
            <p className="text"> {isLoading ? 'loading...' : data?.data[0].deaths}</p>
          </div>
          <div className="btn">
            <p className="title">Recovered</p>
            <img src={recovered} alt="Belize Coronavirus recovered" />
            <p className="text"> {isLoading ? 'loading...' : data?.data[0].recovered}</p>
          </div>
          <div className="btn">
            <p className="title">Active</p>
            <img src={active} alt="Belize Coronavirus Active cases" />
            <p className="text"> {isLoading ? 'loading...' : data?.data[0].active }</p>
          </div>
        </div>
      </div>
  )
}
